
/** @return {string} The path to the missing image URL. */
export const missingImageURL = () => localStorage.getItem("api") + 'configuration/images/presentation/basic/missing';
